import React, { useEffect, useRef } from 'react';

const MessageBubble = ({ role, content }) => (
  <div className={`flex ${role === 'user' ? 'justify-end' : 'justify-start'}`}>
    <div
      className={`max-w-[85%] px-4 py-2.5 rounded-2xl text-sm leading-relaxed ${
        role === 'user'
          ? 'bg-[#D4AF37] text-black rounded-br-md'
          : 'bg-white/[0.06] text-[#E8DCC4] border border-white/[0.05] rounded-bl-md'
      }`}
    >
      {content}
    </div>
  </div>
);

const TypingIndicator = () => (
  <div className="flex justify-start">
    <div className="bg-white/[0.06] border border-white/[0.05] px-4 py-3 rounded-2xl rounded-bl-md flex gap-1">
      <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]/60 animate-pulse" />
      <span
        className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]/60 animate-pulse"
        style={{ animationDelay: '0.15s' }}
      />
      <span
        className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]/60 animate-pulse"
        style={{ animationDelay: '0.3s' }}
      />
    </div>
  </div>
);

export const ChatMessages = ({ messages, isLoading }) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages, isLoading]);

  return (
    <div
      ref={scrollRef}
      className="flex-1 overflow-y-auto px-4 py-4 space-y-3"
      data-testid="chat-messages"
    >
      {messages.map((m, idx) => (
        <MessageBubble key={`msg-${idx}`} role={m.role} content={m.content} />
      ))}
      {isLoading && <TypingIndicator />}
    </div>
  );
};
